/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Auth_Gate_Sign_InInputs */

const en_common_auth_gate_sign_in = /** @type {(inputs: Common_Auth_Gate_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in`)
};

const zh_common_auth_gate_sign_in = /** @type {(inputs: Common_Auth_Gate_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录`)
};

/**
* | output |
* | --- |
* | "Sign in" |
*
* @param {Common_Auth_Gate_Sign_InInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_auth_gate_sign_in = /** @type {((inputs?: Common_Auth_Gate_Sign_InInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Auth_Gate_Sign_InInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_auth_gate_sign_in(inputs)
	return zh_common_auth_gate_sign_in(inputs)
});
export { common_auth_gate_sign_in as "common.auth.gate.sign_in" }